export const normalizeThickness = (raw: string): number | null => {
    const text = raw?.trim().replace(/"$/, '');
    if (!text) return null;
    const value = parseFloat(text);
    return Number.isFinite(value) ? value : null;
};

export const formatThickness = (n: number): string => `${n}"`;
